import React, { useState, useEffect } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import TestimonialWall from './TestimonialWall';
import { apiFetch } from '../lib/apiClient';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Fallback data in case API is empty or unavailable
const fallbackTestimonials = [
  {
    id: '1',
    text: "Nicola ha completamente trasformato il nostro approccio al mercato. In 12 mesi abbiamo triplicato il fatturato e finalmente abbiamo una strategia chiara.",
    name: "Marco V.",
    role: "CEO",
    company: "Azienda Tech B2B",
    rating: 5,
    result: "+280% fatturato",
  },
  {
    id: '2',
    text: "Pensavo di sapere cosa stessi facendo con il marketing. Nicola mi ha aperto gli occhi su quanto stavo lasciando sul tavolo.",
    name: "Giulia T.",
    role: "Founder",
    company: "E-commerce Fashion",
    rating: 5,
    result: "ROI 12x",
  },
  {
    id: '3',
    text: "Finalmente un consulente che parla di numeri, non di vanity metrics. Ogni euro investito è tracciabile e giustificabile.",
    name: "Alessandro M.",
    role: "Direttore Marketing",
    company: "Gruppo Industriale",
    rating: 5,
    result: "-54% CAC",
  },
];

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);
  const [sectionRef, sectionVisible] = useScrollAnimation();

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await apiFetch(`${API_URL}/api/testimonials`);
        if (response.ok) {
          const data = await response.json();
          if (data.length > 0) {
            setTestimonials(data);
          }
        }
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      }
    };
    fetchTestimonials();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="bg-[#f8f9fa] py-20 lg:py-28 relative overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 relative">
        {/* Header */}
        <div className={`text-center mb-12 animate-on-scroll ${sectionVisible ? 'animated' : ''}`}>
          <p className="text-[#d4883a] font-semibold mb-4 tracking-widest text-sm">Testimonianze</p>
          <h2 
            className="text-3xl lg:text-5xl text-[#0b114e] mb-4"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Cosa dicono i <span className="text-[#d4883a]">clienti</span>
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            Risultati reali da imprenditori reali. Nomi abbreviati per riservatezza.
          </p>
        </div>

        {/* Testimonials Wall */}
        <div className={`animate-scale stagger-2 ${sectionVisible ? 'animated' : ''}`}>
          <TestimonialWall testimonials={testimonials} variant="light" />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
